<template>
  <div id="review-report-dialog">
    <ipub-model :title="''"
                width="400px"
                :visable="isVisable"
                :showFooter="false"
                @confirm="confirm"
                @cancel="cancel">
      <div class="content-center"
           style="ipub-p2">
        <ipub-icon type="iconDetails"
                   style="font-size:60px"
                   class="key-color"></ipub-icon>
        <div class="ipub-h1 content-center"
             style="width:400px">
          Please Accept the Reviewers’ Report First!
        </div>
        <div class="mar-b-30">
          <span style="display:block"
                class=" ipub-p2">Total: {{count.total || 0}}</span>
          <span style="display:block"
                class="ipub-p2">Pending editor’s consideration: <font :class="[count.total - count.accept>0?'key-color':'']">{{count.total - count.accept || 0}}</font> </span>
          <span style="display:block"
                class="line-h-12 ipub-p2">Accepted: <font :class="[count.accept==0?'key-color':'']">{{count.accept || 0}}</font></span>
        </div>
        <div class="ipub-p2">
          <ipub-button type="primary"
                       plain
                       style="min-width:155px"
                       @click="cancel">
            Cancel
          </ipub-button>
          <ipub-button type="primary"
                       :disabled="(count.accept == 0 && count.total!=0)"
                       style="margin-left:16px;min-width:155px"
                       @click="confirm">
            Confirm
          </ipub-button>
        </div>
      </div>
    </ipub-model>
  </div>
</template>

<script>

import { minvitedReviewer } from '@/api/reviewer'
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    inputData: {
      type: Object,
      default () {
        return {}
      },
    },
  },
  data () {
    return {
      count: {
        total: 0,
        accept: 0
      }
    }
  },
  computed: {

  },
  watch: {
    isVisable (val) {
      if (!val) {
        this.count = []
      } else {
        this.getList()
      }
    }
  },
  methods: {
    async getList () {
      let data = await minvitedReviewer.countReport({
        manuscriptId: this.inputData.id,
        sign: this.inputData.sign
      })
      data.accept = data.accept ? data.accept : 0
      data.total = data.total ? data.total : 0
      this.count = data
    },
    confirm () {
      this.$emit('confirm', this.inputData.statu)
    },
    cancel () {
      this.$emit('cancel')
    },
  }
}
</script>

<style lang="scss" scoped>
.content-center {
  margin: 0 auto 20px;
  text-align: center;
}
</style>
